var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 22 22",
      },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", {
          attrs: {
            fill: _vm.color,
            d: "M10.8.583a.538.538 0 0 0-.538.539v9.548a.537.537 0 0\n      1-.673.52c-1.564-.422-3.414-.146-5.196 1.186a.546.546 0 0 0-.11.11c-3.244\n      4.344-.217 9.097 3.921 9.097a5.288 5.288 0 0 0\n      5.279-4.97l.01-12.261c0-.298.24-.539.538-.539h4.05a.538.538\n      0 0 0 .538-.538V1.122a.538.538 0 0 0-.538-.539H10.8z",
          },
        }),
        _vm._v(" "),
        _c("path", { attrs: { d: "M0 0h21.784v21.784H0z" } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }